module.exports = __webpack_public_path__ + "img/Light FocusStart.5613a3b9.png";